import React , {Component} from 'react'
import {Link} from 'react-router-dom'
import $ from 'jquery';
import './OrderHistory.css'

window.$ = $;

export default class Card extends Component{
    constructor(props){
        super(props);
        this.state = {
            data: [],
            expanded: false,
           showTitles: false,
           saveCount: props.saveCount
       };
    }
    render(){ 
        return(
        
           <li className="order-item">
           <div className="OIDM">
               <span className="OIIT">{this.props.SKU}</span>
           </div>
           <div className="OIDM">
               <h4 className="OIIT">{this.props.brandName}</h4>
           </div>
           <div className="OIDM">
               <span className="OIIT">{this.props.price}</span>
           </div>
           <div className="OIDM">
               <span className="OIIT"><span className={this.props.status}>{this.props.status}</span></span>
           </div>
           </li>
        )}}